//Ameersha N - 18-08-2025 --- Redux persist keys  ---- start
export const PERSIST_REDUX_KEYS = {
    SELECTED_ROUTE: 'SELECTED_ROUTE',
    UPDATE_APP_INFO: 'UPDATE_APP_INFO',
    UPDATE_PERSIST_TERMS_COND: 'UPDATE_PERSIST_TERMS_COND',
    UPDATE_PERSIST_ABOUT_US: 'UPDATE_PERSIST_ABOUT_US',
    UPDATE_PERSIST_BZ_DYNAMIC: 'UPDATE_PERSIST_BZ_DYNAMIC',
    UPDATE_PERSIST_DISCLAIMER: 'UPDATE_PERSIST_DISCLAIMER',
    UPDATE_PERSIST_EXCHANGE_TIME: 'UPDATE_PERSIST_EXCHANGE_TIME',
    UPDATE_PERSIST_BROKER_INFO: 'UPDATE_PERSIST_BROKER_INFO',
    UPDATE_PERSIST_INDICES_DATA: 'UPDATE_PERSIST_INDICES_DATA',
    UPDATE_PERSIST_WORLD_INDICES_DATA: 'UPDATE_PERSIST_WORLD_INDICES_DATA'
};
//Ameersha N - 18-08-2025 --- Redux persist keys  ---- End

export const LOGIN = {
    GET_LOGIN_PAYLOAD: 'GET_LOGIN_PAYLOAD',
    UPDATE_PASSWORD_SUCCESS: 'UPDATE_PASSWORD_SUCCESS',
    UPDATE_PASSWORD_FAILURE: 'UPDATE_PASSWORD_FAILURE',
    UPDATE_USER_ID: 'UPDATE_USER_ID',
    GET_STATE_AND_CITY_DATA: 'GET_STATE_AND_CITY_DATA',
    UPDATE_SIGNUP: 'UPDATE_SIGNUP',
    GET_USER_LOGIN: 'GET_USER_LOGIN',
    USER_LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
    USER_LOGIN_FAILURE: 'USER_LOGIN_FAILURE',
    UPDATE_IS_LOADING: 'UPDATE_IS_LOADING',
    UPDATE_NEW_PASSWORD_SUCCESS: 'UPDATE_NEW_PASSWORD_SUCCESS',
    UPDATE_NEW_PASSWORD_FAILURE: 'UPDATE_NEW_PASSWORD_FAILURE',
    USER_LOGOUT_SUCCESS: 'USER_LOGOUT_SUCCESS',
    USER_LOGOUT_FAILURE: 'USER_LOGOUT_FAILURE',
    UPDATE_MPIN_ENABLED: 'UPDATE_MPIN_ENABLED',
    UPDATE_FORGOT_MPIN: 'UPDATE_FORGOT_MPIN',
    USER_PROFILE_SUCCESS: 'USER_PROFILE_SUCCESS',
    USER_PROFILE_FAILURE: 'USER_PROFILE_FAILURE',
    USER_GENERATE_QR_CODE_SUCCESS: 'USER_GENERATE_QR_CODE_SUCCESS',
    USER_GENERATE_QR_CODE_FAILURE: 'USER_GENERATE_QR_CODE_FAILURE',
    FORGOT_USER_ID_SUCCESS: 'FORGOT_USER_ID_SUCCESS',
    FORGOT_USER_ID_FAILURE: 'FORGOT_USER_ID_FAILURE',
    // ---BT-113521_CFT_SrikanthRao_17-07-2023
    UPDATE_CFT: "UPDATE_CFT",
    UPDATE_RESET_MPIN: "UPDATE_RESET_MPIN",
    AUTH_SERVICE_DOWN: 'AUTH_SERVICE_DOWN',
    QR_EXPIRE: 'QR_EXPIRE',
    ALIAS_ID: 'ALIAS_ID',
    USER_SESSION_SUCCESS: 'USER_SESSION_SUCCESS'
};

export const WALKTHROUGH = {
    CONTENT_UPDATE: 'CONTENT_UPDATE',
    CREATE_WALKTHROUGH_POPOVER_OBJ: 'CREATE_WALKTHROUGH_POPOVER_OBJ',
    TOGGLE_WALKTHROUGH_MODAL: 'TOGGLE_WALKTHROUGH_MODAL'
};

export const GUEST_LOGIN = {
    VALIDATE_GUEST_OTP_SUCCESS: 'VALIDATE_GUEST_OTP_SUCCESS',
    VALIDATE_GUEST_OTP_FAILURE: 'VALIDATE_GUEST_OTP_FAILURE',
    SET_GUEST_REG_DETAILS_SUCCESS: 'SET_GUEST_REG_DETAILS_SUCCESS',
    SET_GUEST_REG_DETAILS_FAILURE: 'SET_GUEST_REG_DETAILS_FAILURE'
};

export const APP_INFO = {
    GET_APPINFO_SUCCESS: 'GET_APPINFO_SUCCESS',
    GET_APPINFO_FAILURE: 'GET_APPINFO_FAILURE',

    UPDATE_CDN_BASE_URL: 'UPDATE_CDN_BASE_URL',

    GET_TERMS_AND_CONDITION_SUCCESS: 'GET_TERMS_AND_CONDITION_SUCCESS',
    GET_TERMS_AND_CONDITION_FAILURE: 'GET_TERMS_AND_CONDITION_FAILURE',

    GET_ABOUT_US_SUCCESS: 'GET_ABOUT_US_SUCCESS',
    GET_ABOUT_US_FAILURE: 'GET_ABOUT_US_FAILURE',


    GET_DISCLAIMER_SUCCESS: 'GET_DISCLAIMER_SUCCESS',
    GET_DISCLAIMER_FAILURE: 'GET_DISCLAIMER_FAILURE',

    GET_EXCHANGETIMINGS_SUCCESS: 'GET_EXCHANGETIMINGS_SUCCESS',
    GET_EXCHANGETIMINGS_FAILURE: 'GET_EXCHANGETIMINGS_FAILURE',

    GET_STATES_AND_CITIES_SUCCESS: 'GET_STATES_AND_CITIES_SUCCESS',
    GET_STATES_AND_CITIES_FAILURE: 'GET_STATES_AND_CITIES_FAILURE',

    SET_CHART_ATTRIBUTES: 'SET_CHART_ATTRIBUTES',
    UPDATE_DYNAMIC_MENUS: 'UPDATE_DYNAMIC_MENUS',

    GET_BROKERINFORMATION_SUCCESS: 'GET_BROKERINFORMATION_SUCCESS',
    GET_BROKERINFORMATION_FAILURE: 'GET_BROKERINFORMATION_FAILURE',

    UPDATE_INAPP_IFRAME: 'UPDATE_INAPP_IFRAME',

    SET_DASH_MENU: "SET_DASH_MENU",
};

export const NET_POSITION_INFO = {
    GET_NETPOSITION_SUCCESS: 'GET_NETPOSITION_SUCCESS',
    GET_NETPOSITION_FAILURE: 'GET_NETPOSITION_FAILURE',
    UPDATE_OVERALL_POSITIONS: 'UPDATE_OVERALL_POSITIONS',
    UPDATE_TODAYS_POSITIONS: 'UPDATE_TODAYS_POSITIONS',
    UPDATE_INTEROP_OVERALL_POSITIONS: 'UPDATE_INTEROP_OVERALL_POSITIONS',
    UPDATE_INTEROP_TODAYS_POSITIONS: 'UPDATE_INTEROP_TODAYS_POSITIONS',
    UPDATE_NETPOSITION_COL_DEF: 'UPDATE_NETPOSITION_COL_DEF',
    // Azeem K : 22-02-2024 : BT-102298  BSEEQ NetPositions  – Start 
    UPDATE_TODAYS_POSITIONS_INDEXES: 'UPDATE_TODAYS_POSITIONS_INDEXES',
    UPDATE_OVERALL_POSITIONS_INDEXES: 'UPDATE_OVERALL_POSITIONS_INDEXES',
    NET_POSITION_API_PENDING: 'NET_POSITION_API_PENDING',
    // Azeem K : 22-02-2024 : BT-102298  BSEEQ NetPositions  – End 
};

export const DASHBOARD = {
    GET_LIVE_PULSE: 'GET_LIVE_PULSE',
    // GET_LIVE_PULSE_BSE: 'GET_LIVE_PULSE_BSE',
    GET_INVESTMENTS: 'GET_INVESTMENTS',
    GET_NEW_PRODUCTS: 'GET_NEW_PRODUCTS',
    GET_LIVE_PULSE_FAILURE: 'GET_LIVE_PULSE_FAILURE',
};

//Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices  -- Start
export const INDICES = {
    GET_WORLD_INDICES_SUCCESS: 'GET_WORLD_INDICES_SUCCESS',
    GET_WORLD_INDICES_FAILURE: 'GET_WORLD_INDICES_FAILURE',
    GET_INDICES_SUCCESS: 'GET_INDICES_SUCCESS',
    GET_INDICES_FAILURE: 'GET_INDICES_FAILURE',
    GET_CONSTITUENTS_DATA_SUCCESS: 'GET_CONSTITUENTS_DATA_SUCCESS',
    GET_CONSTITUENTS_DATA_FAILURE: 'GET_CONSTITUENTS_DATA_FAILURE',
    GET_INDICES_FUTURE_DATA_SUCCESS: 'GET_INDICES_FUTURE_DATA_SUCCESS',
    GET_INDICES_FUTURE_DATA_FAILURE: 'GET_INDICES_FUTURE_DATA_FAILURE',
    SET_IS_INDICES_OVERVIEW: 'SET_IS_INDICES_OVERVIEW',
    RESET_INDICE_OVERVIEW: 'RESET_INDICE_OVERVIEW',
    SET_INDICE_OVERVIEW_DATA: 'SET_INDICE_OVERVIEW_DATA',
    SCROLL_POSITION: 'SCROLL_POSITION',
    UPDATE_LOCAL_INDICES: 'UPDATE_LOCAL_INDICES',
    UPDATE_FAVORITE_INDICES_SUCCESS: 'UPDATE_FAVORITE_INDICES_SUCCESS', //Prachi T - 27-11-2023 :- BT-104813 -- Dashboard Indices
    UPDATE_HEADER_INDICES: "UPDATE_HEADER_INDICES", // Parshva S - 12/12/2023 - BT-123521 : Breeze - Header Indices Start
    GET_CONSTITUENTS_INDEXES: 'GET_CONSTITUENTS_INDEXES',// Azeem K -05-07-2024 : Constituents Optimization
    UPDATE_CONSTITUENT_VIEW_API_STATUS: 'UPDATE_CONSTITUENT_VIEW_API_STATUS'
};
//Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices  --End
export const WATCHLIST = {
    GET_WATCHLIST: 'GET_WATCHLIST',
    GET_DONT_MISS_INFO: "GET_DONT_MISS_INFO",
    UPDATE_ACTIVE_WATCHLIST: 'UPDATE_ACTIVE_WATCHLIST',
    UPDATE_SELECTED_WATCHLIST: 'UPDATE_SELECTED_WATCHLIST',
    REMOVE_WATCHLIST: "REMOVE_WATCHLIST",
    REMOVE_OPENED_WATCHLIST: "REMOVE_OPENED_WATCHLIST",
    UPDATE_OPEN_WATCHLIST: "UPDATE_OPEN_WATCHLIST",
    CHOOSE_WATCHLIST: "CHOOSE_WATCHLIST",
    UPDATE_WATCHLISTS: 'UPDATE_WATCHLISTS',
    UPDATED_OPEN_WATCHLIST: 'UPDATED_OPEN_WATCHLIST',
    GET_WATCHLIST_GRID: 'GET_WATCHLIST_GRID',
    UPDATE_GLOBAL_WATCHLIST: 'UPDATE_GLOBAL_WATCHLIST',
    GET_COLUMNDEF_SUCCESS: 'GET_COLUMNDEF_SUCCESS',
    GET_COLUMNDEF_FAILURE: 'GET_COLUMNDEF_FAILURE',
    GET_WHATS_HOT_DATA_SUCCESS: "GET_WHATS_HOT_DATA_SUCCESS",
    GET_WHATS_HOT_DATA_FAILURE: "GET_WHATS_HOT_DATA_FAILURE",
    GET_DONT_MISS_DATA: "GET_DONT_MISS_DATA",
    UPDATE_GUEST_IS_LOADING: "UPDATE_GUEST_IS_LOADING",
    UPDATE_WATCHLISTS_INFO: "UPDATE_WATCHLISTS_INFO",
    UPDATE_WATCHLIST_IS_PRESENT: 'UPDATE_WATCHLIST_IS_PRESENT',
    UPDATE_WATCHLIST_LOADING: 'UPDATE_WATCHLIST_LOADING',

    //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - Start
    UPDATE_GLOBAL_COLUMN_PROFILES: 'UPDATE_GLOBAL_COLUMN_PROFILES',
    UPDATE_USER_COLUMN_PROFILES: 'UPDATE_USER_COLUMN_PROFILES',
    UPDATE_IS_COLUMN_PRESENT: 'UPDATE_IS_COLUMN_PRESENT',
    UPDATE_STR_VIEW_TYPE: 'UPDATE_STR_VIEW_TYPE',
    UPDATE_IS_PIVIOT_PRESENT: 'UPDATE_IS_PIVIOT_PRESENT',
    UPDATE_TENANT_COLUMN_PROFILES: 'UPDATE_TENANT_COLUMN_PROFILES',
    UPDATE_VIEW_WISE_COLUMN_PROFILES: 'UPDATE_VIEW_WISE_COLUMN_PROFILES',
    UPDATE_COLUMNS_UPTO_DATE: 'UPDATE_COLUMNS_UPTO_DATE',
    //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - End
    UPDATE_DASHBOARD_WATCHLIST: 'UPDATE_DASHBOARD_WATCHLIST',
    SELECT_SCRIP_FOR_DELETE: 'SELECT_SCRIP_FOR_DELETE',
    GET_SCRIPS_ADDITIONAL_INFO_SUCCESS: 'GET_SCRIPS_ADDITIONAL_INFO_SUCCESS',
    GET_SCRIPS_ADDITIONAL_INFO_FAILURE: 'GET_SCRIPS_ADDITIONAL_INFO_FAILURE',
    GET_FOCUS_CARD: 'GET_FOCUS_CARD',
    //Ameersha N -12-12-2023 - BREEZE - BT-95888 -Create Watchlist -Start
    UPDATE_HOLDINGS_WATCHLIST: 'UPDATE_HOLDINGS_WATCHLIST',
    //Ameersha N -12-12-2023 - BREEZE - BT-95888 -Create Watchlist -End
    WATCHLIST_SCRIP_INDEXES: 'WATCHLIST_SCRIP_INDEXES',// Azeem K -05-07-2024 : Watchlist Optimization
    UPDATE_GROUPED_DONT_MISS: "UPDATE_GROUPED_DONT_MISS",
    // Deepti b. BT-107398 [18/11/2024]: selected heatmap tile
    UPDATE_SELECTED_HEATMAP_TILE_WATCHLIST: 'UPDATE_SELECTED_HEATMAP_TILE_WATCHLIST',
    IS_POPOVER_OPEN: "IS_POPOVER_OPEN"
};

export const NOTES = {
    GET_NOTES: 'GET_NOTES',
    UPDATE_NOTES: 'UPDATE_NOTES',

};

export const OTP = {
    USER_VERIFY_OTP_SUCCESS: 'USER_VERIFY_OTP_SUCCESS',
    USER_VERIFY_OTP_FAILURE: 'USER_VERIFY_OTP_FAILURE',
    USER_SENT_OTP_SUCCESS: 'USER_SENT_OTP_SUCCESS',
    USER_SENT_OTP_FAILURE: 'USER_SENT_OTP_FAILURE',
    USER_SENT_OTP_MPIN_SUCCESS: 'USER_SENT_OTP_MPIN_SUCCESS',
    USER_SENT_OTP_MPIN_FAILURE: 'USER_SENT_OTP_MPIN_FAILURE',
    USER_SENT_OTP_LOADING: 'USER_SENT_OTP_LOADING'
};

export const TOTP = {
    USER_REGISTER_TOTP_SUCCESS: 'USER_REGISTER_TOTP_SUCCESS',
    USER_REGISTER_TOTP_FAILURE: 'USER_REGISTER_TOTP_FAILURE',
};
export const USER_REGISTER = {
    USER_DETAILS_SUCCESS: 'USER_DETAILS_SUCCESS',
    USER_DETAILS_FAILURE: 'USER_DETAILS_FAILURE',
    USER_REGISTER_SUCCESS: 'USER_REGISTER_SUCCESS',
    USER_REGISTER_FAILURE: 'USER_REGISTER_FAILURE',
    USER_REGISTER_MPIN_SUCCESS: 'USER_REGISTER_MPIN_SUCCESS',
    USER_REGISTER_MPIN_FAILURE: 'USER_REGISTER_MPIN_FAILURE',
    USER_CHANGE_MPIN_SUCCESS: 'USER_CHANGE_MPIN_SUCCESS',
    USER_CHANGE_MPIN_FAILURE: 'USER_CHANGE_MPIN_FAILURE'
};

export const NETPOSITION = {

    UPDATE_ACTIVE_POSITIONS: 'UPDATE_ACTIVE_POSITIONS',
    GET_WATCHLIST_POSITION: 'GET_WATCHLIST_POSITION',
    UPDATE_ACTIVE_NET_POSITION: 'UPDATE_ACTIVE_NET_POSITION',
    GET_NET_POSITION: 'GET_NET_POSITION',
    GET_NET_POSITIONS_SUMMARY: 'GET_NET_POSITIONS_SUMMARY',
    UPDATE_POSITION_TYPES: 'UPDATE_POSITION_TYPES',
    GET_NETPOSITION_COLUMNDEF_SUCCESS: 'GET_NETPOSITION_COLUMNDEF_SUCCESS',
    GET_NETPOSITION_COLUMNDEF_FAILURE: 'GET_NETPOSITION_COLUMNDEF_FAILURE',
    UPDATE_TODAY_PL: 'UPDATE_TODAY_PL',
    UPDATE_OVERALL_PL: 'UPDATE_OVERALL_PL',
    CONVERT_POSITION_SUCCESS: 'CONVERT_POSITION_SUCCESS',
    CONVERT_POSITION_FAILURE: 'CONVERT_POSITION_FAILURE',
    SQUAREOFF_POSITION_SUCCESS: 'SQUAREOFF_POSITION_SUCCESS',
    SQUAREOFF_POSITION_FAILURE: 'SQUAREOFF_POSITION_FAILURE',
    UPDATE_IS_SQUARE_OFF: 'UPDATE_IS_SQUARE_OFF',
    CONVERT_OR_SQUAREOFF_POSITION_API_PENDING: 'CONVERT_OR_SQUAREOFF_POSITION_API_PENDING',
};
export const HOLDINGS = {
    UPDATE_SIDEBAR_HOLDINGS: 'UPDATE_SIDEBAR_HOLDINGS',
    GET_SIDEBAR_HOLDINGS: 'GET_SIDEBAR_HOLDINGS',
    GET_HOLDINGS: 'GET_HOLDINGS',
    GET_HOLDINGS_SUCCESS: 'GET_HOLDINGS_SUCCESS',
    GET_HOLDINGS_FAILURE: 'GET_HOLDINGS_FAILURE',
    GET_HOLDINGS_ADDITIONAL_DETAILS_SUCCESS: 'GET_HOLDINGS_ADDITIONAL_DETAILS_SUCCESS',
    GET_HOLDINGS_ADDITIONAL_DETAILS_FAILURE: 'GET_HOLDINGS_ADDITIONAL_DETAILS_FAILURE',
    UPDATE_HOLDINGS_SCRIPS: 'UPDATE_HOLDINGS_SCRIPS',
    UPDATE_HOLDINGS_TYPE: 'UPDATE_HOLDINGS_TYPE',
    UPDATE_ACTIVE_HOLDINGS: 'UPDATE_ACTIVE_HOLDINGS',
    UPDATE_WATCHLIST_GRID_CONVERTED_HOLDINGS_SCRIPS: 'UPDATE_WATCHLIST_GRID_CONVERTED_HOLDINGS_SCRIPS',
    UPDATE_HOLDINGS_COLUMN_DEF: 'UPDATE_HOLDINGS_COLUMN_DEF',
    UPDATE_HOLDING_VIEW: "UPDATE_HOLDING_VIEW",

};
export const EVENTS = {
    GET_EVENT: 'GET_EVENT',
    GET_EVENTS_SUCCESS: 'GET_EVENTS_SUCCESS',
    GET_EVENTS_FAILURE: 'GET_EVENTS_FAILURE',
    GET_EVENT_PENDING_STATUS: "GET_EVENT_PENDING_STATUS",
    UPDATE_ACTIVE_EVENT_TAB: 'UPDATE_ACTIVE_EVENT_TAB',
    UPDATE_EVENT_DATE: 'UPDATE_EVENT_DATE',
    UPDATE_EVENTS_SEARCH_TEXT: 'UPDATE_EVENTS_SEARCH_TEXT',
    CLEAR_EVENTS_STATES: 'CLEAR_EVENTS_STATES',
    //MAhesh S:26-10-23 :BT-107375 - Breeze - Scrip -info-events - Start
    GET_BOARD_MEETING_SUCCESS: 'GET_BOARD_MEETING_SUCCESS',
    GET_BOARD_MEETING_FAILURE: 'GET_BOARD_MEETING_FAILURE',
    GET_BOOK_CLOSURE_SUCCESS: 'GET_BOOK_CLOSURE_SUCCESS',
    GET_BOOK_CLOSURE_FAILURE: 'GET_BOOK_CLOSURE_FAILURE',
    GET_AGM_SUCCESS: 'GET_AGM_SUCCESS',
    GET_AGM_FAILURE: 'GET_AGM_FAILURE',
    GET_EGM_SUCCESS: 'GET_EGM_SUCCESS',
    GET_EGM_FAILURE: 'GET_EGM_FAILURE',
    GET_SPLITS_DATA_SUCCESS: 'GET_SPLITS_DATA_SUCCESS',
    GET_SPLITS_DATA_FAILURE: 'GET_SPLITS_DATA_FAILURE',
    GET_DIVIDEND_DATA_SUCCESS: 'GET_DIVIDEND_DATA_SUCCESS',
    GET_DIVIDEND_DATA_FAILURE: 'GET_DIVIDEND_DATA_FAILURE',
    GET_BUY_BACK_SUCCESS: 'GET_BUY_BACK_SUCCESS',
    GET_BUY_BACK_FAILURE: 'GET_BUY_BACK_FAILURE',
    GET_RIGHTS_DATA_SUCCESS: 'GET_RIGHTS_DATA_SUCCESS',
    GET_RIGHTS_DATA_FAILURE: 'GET_RIGHTS_DATA_FAILURE',
    GET_BONUS_DATA_SUCCESS: 'GET_BONUS_DATA_SUCCESS',
    GET_BONUS_DATA_FAILURE: 'GET_BONUS_DATA_FAILURE',
    IS_CORPORATE_ACTION_PENDING: "IS_CORPORATE_ACTION_PENDING",
    //MAhesh S:26-10-23 :BT-107375 - Breeze - Scrip -info-events - End
    UPDATE_EVENT_DETAILS: 'UPDATE_EVENT_DETAILS',
};
export const PORTFOLIO = {
    GET_PORTFOLIO: 'GET_PORTFOLIO',
};

export const ORDERS = {
    GET_HORIZONTAL_SCRIP_PRICE: 'GET_HORIZONTAL_SCRIP_PRICE',// on row selection price reflection
    UPDATE_SHORTFALL_AMOUNT: 'UPDATE_SHORTFALL_AMOUNT',
    UPDATE_ACTIVE_ORDERS: 'UPDATE_ACTIVE_ORDERS',
    GET_SCRIP_ORDER_INFO: 'GET_SCRIPT_ORDER_INFO',
    GET_ALL_ORDERS: 'GET_ALL_ORDERS',
    UPDATE_IS_LOADING_ORDER_MARGIN_INFO: 'UPDATE_IS_LOADING_ORDER_MARGIN_INFO',
    GET_ORDER_MARGIN_INFO_SUCCESS: 'FUNDS_ORDER_MARGIN_INFO_SUCCESS',
    GET_ORDER_MARGIN_INFO_FAILURE: 'FUNDS_ORDER_MARGIN_INFO_FAILURE',

    GET_EXCHANGE_WISE_SCRIP_INFO_SUCCESS: 'GET_EXCHANGE_WISE_SCRIP_INFO_SUCCESS',
    GET_EXCHANGE_WISE_SCRIP_INFO_FAILURE: 'GET_EXCHANGE_WISE_SCRIP_INFO_FAILURE',

    GET_EQSIP_SCRIP_MASTER_SUCCESS: 'GET_EQSIP_SCRIP_MASTER_SUCCESS',
    GET_EQSIP_SCRIP_MASTER_FAILURE: 'GET_EQSIP_SCRIP_MASTER_FAILURE',
    GET_DYNAMIC_PRODUCT_TYPES_SUCCESS: 'GET_DYNAMIC_PRODUCT_TYPES_SUCCESS',
    GET_DYNAMIC_PRODUCT_TYPES_FAILURE: 'GET_DYNAMIC_PRODUCT_TYPES_FAILURE',

    PLACE_SINGLESCRIP_ORDER_SUCCESS: 'PLACE_SINGLESCRIP_ORDER_SUCCESS',
    PLACE_SINGLESCRIP_ORDER_FAILURE: 'PLACE_SINGLESCRIP_ORDER_FAILURE',
    PLACE_MULTILEG_ORDER_SUCCESS: 'PLACE_MULTILEG_ORDER_SUCCESS',
    PLACE_MULTILEG_ORDER_FAILURE: 'PLACE_MULTILEG_ORDER_FAILURE',

    UPDATE_ALL_ORDERS: 'UPDATE_ALL_ORDERS',
    // GET_BROKERAGE_CHARGES: 'GET_BROKERAGE_CHARGES',

    PLACE_SIP_ORDER: "PLACE_SIP_ORDER",
    PLACE_SIP_ORDER_SUCCESS: "PLACE_SIP_ORDER_SUCCESS",
    PLACE_SIP_ORDER_FAILURE: "PLACE_SIP_ORDER_FAILURE",

    GET_ALL_SIP_ORDERS: " GET_ALL_SIP_ORDERS",

    UPDATE_SIP_ORDER: "UPDATE_SIP_ORDER",
    UPDATE_SIP_ORDER_SUCCESS: "UPDATE_SIP_ORDER_SUCCESS",
    UPDATE_SIP_ORDER_FAILURE: "UPDATE_SIP_ORDER_FAILURE",

    CANCEL_SIP_ORDER: "CANCEL_SIP_ORDER",
    CANCEL_SIP_ORDER_SUCCESS: "CANCEL_SIP_ORDER_SUCCESS",
    CANCEL_SIP_ORDER_FAILURE: "CANCEL_SIP_ORDER_FAILURE",

    GET_SIP_SETTING_DETAILS: "GET_SIP_SETTING_DETAILS",
    GET_SIP_SETTING_DETAILS_SUCCESS: "GET_SIP_SETTING_DETAILS_SUCCESS",
    GET_SIP_SETTING_DETAILS_FAILURE: "GET_SIP_SETTING_DETAILS_FAILURE",

    GET_SIP_HISTORY: "GET_SIP_HISTORY",
    GET_SIP_ORDER_HISTORY_SUCCESS: "GET_SIP_HISTORY_SUCCESS",
    GET_SIP_ORDER_HISTORY_FAILURE: "GET_SIP_HISTORY_FAILURE",

    UPDATE_ORDER_TYPES: 'UPDATE_ORDER_TYPES',
    GET_ORDER_TRADES: 'GET_ORDER_TRADES',

    GET_MUITISCRIPT_SECONDLEG_SUCCESS: 'GET_MUITISCRIPT_SECONDLEG_SUCCESS',
    GET_MUITISCRIPT_SECONDLEG_FAILURE: 'GET_MUITISCRIPT_SECONDLEG_FAILURE',

    GET_MULTILEG_FUTOPTION_SUCCESS: "GET_MULTILEG_FUTOPTION_SUCCESS",
    GET_MULTILEG_FUTOPTION_FAILURE: "GET_MULTILEG_FUTOPTION_FAILURE",

    GET_PLACE_MULTILEG_ORDER_SUCESS: "GET_PLACE_MULTILEG_ORDER_SUCESS",
    GET_PLACE_MULTILEG_ORDER_FAILURE: "GET_PLACE_MULTILEG_ORDER_FAILURE",
    MULTI_LEG_DATA: "MULTI_LEG_DATA",
    MULTILEG_DATA_FOR_BROKERAGE: 'MULTILEG_DATA_FOR_BROKERAGE',
    GET_SPREAD_ORDER_SUCESS: "GET_SPREAD_ORDER_SUCESS",
    GET_SPREAD_ORDER_FAILURE: "GET_SPREAD_ORDER_FAILURE",
    HANDLE_SPREAD_SIDE_ORDER: "HANDLE_SPREAD_SIDE_ORDER",
    PLACE_MULTISCRIPT_ORDERCART_SUCCESS: "PLACE_MULTISCRIPT_ORDERCART_SUCCESS",
    PLACE_MULTISCRIPT_ORDERCART_FAILURE: "PLACE_MULTISCRIPT_ORDERCART_FAILURE",

    ORDERCART_MULTISCRIPT_SUCCESS: "ORDERCART_MULTISCRIPT_SUCCESS",
    ORDERCART_MULTISCRIPT_FAILURE: "ORDERCART_MULTISCRIPT_FAILURE",

    GET_SIP_ORDER_FREQUENCY: 'GET_SIP_ORDER_FREQUENCY',
    GET_ORDER_INFO: 'GET_ORDER_INFO',

    GET_ALL_MULTI_SCRIP_ORDER_SUCCESS: 'GET_ALL_MULTI_SCRIP_ORDER_SUCCESS',
    GET_ALL_MULTI_SCRIP_ORDER_FAILURE: 'GET_ALL_MULTI_SCRIP_ORDER_FAILURE',
    GET_ALL_MULTI_LEG_ORDER_SUCCESS: 'GET_ALL_MULTI_LEG_ORDER_SUCCESS',
    GET_ALL_MULTI_LEG_ORDER_FAILURE: 'GET_ALL_MULTI_LEG_ORDER_FAILURE',
    GET_ALL_SPREAD_ORDER_SUCCESS: 'GET_ALL_SPREAD_ORDER_SUCCESS',
    GET_ALL_SPREAD_ORDER_FAILURE: 'GET_ALL_SPREAD_ORDER_FAILURE',

    GET_ALL_OPEN_ORDER_SUCCESS: 'GET_ALL_OPEN_ORDER_SUCCESS',
    GET_ALL_OPEN_ORDER_FAILURE: 'GET_ALL_OPEN_ORDER_FAILURE',
    CLEAR_ALL_OPEN_ORDERS: 'CLEAR_ALL_OPEN_ORDERS', // Vinit Raut : 12-02-2024 : BT-127175 - Breeze – Changes for Spread and GTD as per updated USD and Screen -- Start

    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start

    GET_MARGIN_PLUS_PARAMS_SUCCESS: 'GET_MARGIN_PLUS_PARAMS_SUCCESS',
    GET_MARGIN_PLUS_PARAMS_FAILURE: 'GET_MARGIN_PLUS_PARAMS_FAILURE',

    GET_BANNED_SCRIP_STATUS_SUCCESS: 'GET_BANNED_SCRIP_STATUS_SUCCESS',
    GET_BANNED_SCRIP_STATUS_FAILURE: 'GET_BANNED_SCRIP_STATUS_FAILURE',
    GET_BANNED_SCRIP_LIST_SUCCESS: 'GET_BANNED_SCRIP_LIST_SUCCESS',
    GET_BANNED_SCRIP_LIST_FAILURE: 'GET_BANNED_SCRIP_LIST_FAILURE',
    GET_LTP_PRICE_BAND_SUCCESS: 'GET_LTP_PRICE_BAND_SUCCESS',
    GET_LTP_PRICE_BAND_FAILURE: 'GET_LTP_PRICE_BAND_FAILURE',


    GET_MARKET_STATUS_SUCCESS: 'GET_MARKET_STATUS_SUCCESS',
    GET_MARKET_STATUS_FAILURE: 'GET_MARKET_STATUS_FAILURE',

    UPDATE_SINGLE_SCRIP_IS_ORDER_CONFIRMED: 'UPDATE_SINGLE_SCRIP_IS_ORDER_CONFIRMED',
    // Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - Start
    UPDATE_MULTI_LEG_IS_ORDER_CONFIRMED: 'UPDATE_MULTI_LEG_IS_ORDER_CONFIRMED',
    UPDATE_SPREAD_IS_ORDER_CONFIRMED: 'UPDATE_SPREAD_IS_ORDER_CONFIRMED',
    // Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - End
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
    UPDATE_SPREAD_INFO_FOR_BROKERAGE: 'UPDATE_SPREAD_INFO_FOR_BROKERAGE',
    UPDATE_SPREAD_ORDER_INFO: 'UPDATE_SPREAD_ORDER_INFO',
    GET_ALL_GTD_ORDER_SUCCESS: 'GET_ALL_GTD_ORDER_SUCCESS',
    //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
    GET_OPEN_GTD_ORDER: 'GET_OPEN_GTD_ORDER',
    GET_COMPLETED_GTD_ORDER: 'GET_COMPLETED_GTD_ORDER',
    //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
    UPDATE_ALL_GTD_ORDER_SUCCESS: 'UPDATE_ALL_GTD_ORDER_SUCCESS',
    UPDATE_OPEN_GTD_ORDER: 'UPDATE_OPEN_GTD_ORDER',
    UPDATE_COMPLETED_GTD_ORDER: 'UPDATE_COMPLETED_GTD_ORDER',
    UPDATE_ORDER_SINGLE_SCRIP_COL_DEF: 'UPDATE_ORDER_SINGLE_SCRIP_COL_DEF',
    UPDATE_MULTI_LEG_COL_DEF: 'UPDATE_MULTI_LEG_COL_DEF',
    UPDATE_GTD_COL_DEF: 'UPDATE_GTD_COL_DEF',
    UPDATE_SPREAD_COL_DEF: 'UPDATE_SPREAD_COL_DEF',
    UPDATE_EQUITY_SEIP_COL_DEF: 'UPDATE_EQUITY_SEIP_COL_DEF',
    GET_COMPLETED_ORDERS_SUCCESS: 'GET_COMPLETED_ORDERS_SUCCESS',
    GET_COMPLETED_ORDERS_FAILURE: 'GET_COMPLETED_ORDERS_FAILURE',
    GET_OPEN_ORDERS_SUCCESS: 'GET_OPEN_ORDERS_SUCCESS',
    GET_OPEN_ORDERS_FAILURE: 'GET_OPEN_ORDERS_FAILURE',
    GET_SINGLE_SCRIP_ORDER_COLUMNDEFS_SUCCESS: 'GET_SINGLE_SCRIP_ORDER_COLUMNDEFS_SUCCESS',
    GET_SINGLE_SCRIP_ORDER_COLUMNDEFS_FAILURE: 'GET_SINGLE_SCRIP_ORDER_COLUMNDEFS_FAILURE',
    GET_MULTI_LEG_ORDER_COLUMNDEFS_SUCCESS: 'GET_MULTI_LEG_ORDER_COLUMNDEFS_SUCCESS',
    GET_MULTI_LEG_ORDER_COLUMNDEFS_FAILURE: 'GET_MULTI_LEG_ORDER_COLUMNDEFS_FAILURE',
    GET_SPREAD_ORDER_COLUMNDEFS_SUCCESS: 'GET_SPREAD_ORDER_COLUMNDEFS_SUCCESS',
    GET_SPREAD_ORDER_COLUMNDEFS_FAILURE: 'GET_SPREAD_ORDER_COLUMNDEFS_FAILURE',
    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
    GET_SIP_EQUITY_ORDERBOOK_COLUMNS_SUCCESS: 'GET_SIP_EQUITY_ORDERBOOK_COLUMNS_SUCCESS',
    GET_SIP_EQUITY_ORDERBOOK_COLUMNS_FAILURE: 'GET_SIP_EQUITY_ORDERBOOK_COLUMNS_FAILURE',
    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End
    //Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
    UPDATE_SINGLE_COMPLETED_ORDERS: 'UPDATE_SINGLE_COMPLETED_ORDERS',
    UPDATE_SINGLE_ALL_ORDERS: 'UPDATE_SINGLE_ALL_ORDERS',
    UPDATE_SINGLE_OPEN_ORDERS: 'UPDATE_SINGLE_OPEN_ORDERS',
    GET_ALL_SINGLE_SCRIP_ORDER_LENGTH: 'GET_ALL_SINGLE_SCRIP_ORDER_LENGTH',
    GET_OPEN_SINGLE_SCRIP_ORDER_LENGTH: 'GET_OPEN_SINGLE_SCRIP_ORDER_LENGTH',
    GET_COMPLETED_SINGLE_SCRIP_ORDER_LENGTH: 'GET_COMPLETED_SINGLE_SCRIP_ORDER_LENGTH',
    //Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
    UPDATE_SPREAD_COMPLETED_ORDERS: 'UPDATE_SPREAD_COMPLETED_ORDERS',
    UPDATE_SPREAD_ALL_ORDERS: 'UPDATE_SPREAD_ALL_ORDERS',
    UPDATE_SPREAD_OPEN_ORDERS: 'UPDATE_SPREAD_OPEN_ORDERS',
    GET_ALL_SPREAD_ORDER_LENGTH: 'GET_ALL_SPREAD_ORDER_LENGTH',
    GET_OPEN_SPREAD_ORDER_LENGTH: 'GET_OPEN_SPREAD_ORDER_LENGTH',
    GET_COMPLETED_SPREAD_ORDER_LENGTH: 'GET_COMPLETED_SPREAD_ORDER_LENGTH',
    GET_COMPLETED_SPREAD_ORDERS_SUCCESS: 'GET_COMPLETED_SPREAD_ORDERS_SUCCESS',
    GET_COMPLETED_SPREAD_ORDERS_FAILURE: 'GET_COMPLETED_SPREAD_ORDERS_FAILURE',
    GET_ALL_SPREAD_ORDERS_SUCCESS: 'GET_ALL_SPREAD_ORDERS_SUCCESS',
    GET_ALL_SPREAD_ORDERS_FAILURE: 'GET_ALL_SPREAD_ORDERS_FAILURE',
    GET_OPEN_ORDERS_SPREAD_SUCCESS: 'GET_OPEN_ORDERS_SPREAD_SUCCESS',
    GET_OPEN_ORDERS_SPREAD_FAILURE: 'GET_OPEN_ORDERS_SPREAD_FAILURE',
    SPREAD_ORDERS_LOADING: 'SPREAD_ORDERS_LOADING',
    // Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
    GET_ALL_SIP_ORDERS_SUCCESS: 'GET_ALL_SIP_ORDERS_SUCCESS',
    GET_ALL_SIP_ORDERS_FAILURE: 'GET_ALL_SIP_ORDERS_FAILURE',
    GET_OPEN_SIP_ORDERS_SUCCESS: 'GET_OPEN_SIP_ORDERS_SUCCESS',
    GET_OPEN_SIP_ORDERS_FAILURE: 'GET_OPEN_SIP_ORDERS_FAILURE',
    GET_COMPLETED_SIP_ORDERS_SUCCESS: 'GET_COMPLETED_SIP_ORDERS_SUCCESS',
    GET_COMPLETED_SIP_ORDERS_FAILURE: 'GET_COMPLETED_SIP_ORDERS_FAILURE',
    UPDATE_ALL_SIP_ORDERS: 'UPDATE_ALL_SIP_ORDERS',
    UPDATE_OPEN_SIP_ORDERS: 'UPDATE_OPEN_SIP_ORDERS',
    UPDATE_COMPLETED_SIP_ORDERS: 'UPDATE_COMPLETED_SIP_ORDERS',
    SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
    // Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End
    SET_FILTER: 'SET_FILTER', //Vaibhav Singh: 05-02-24: BT-104814: Added filter object
    UPDATE_RESET_SCRIP: 'UPDATE_RESET_SCRIP', //Ameersha N : 08-01-2024 : BT-102298 - Breeze - Single Scrip Order entry - Resetign scrip scrplot and trigger when a search scrip is selected 
    // Azeem K : 22-02-2024 : BT-102298  BSEEQ OrderBook  – Start 
    ORDERS_API_PENDING: 'ORDERS_API_PENDING',
    // Azeem K : 22-02-2024 : BT-102298  BSEEQ OrderBook  – Start 
    IS_MULTIPLE_ORDERS_CANCEL_INPROCESS: 'IS_MULTIPLE_ORDERS_CANCEL_INPROCESS',//Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments 
    UPDATE_BUY_SELL: 'UPDATE_BUY_SELL',//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry
    //Azeem K : 26-03-2024 : BT-102298 - Breeze - Single Scrip Order entry -Loader added on order entry - Start
    ORDERS_ENTRY_API_PENDING: 'ORDERS_ENTRY_API_PENDING',
    //Azeem K : 26-03-2024 : BT-102298 - Breeze - Single Scrip Order entry -Loader added on order entry - End
    // Ajitesh 12-07-2024 Actions for multileg pagination start
    UPDATE_MULTILEG_ADD_LEG_MODAL_ACTIVE_TAB: 'UPDATE_MULTILEG_ADD_LEG_MODAL_ACTIVE_TAB',
    UPDATE_MULTILEG_COMPLETED_ORDERS: 'UPDATE_MULTILEG_COMPLETED_ORDERS',
    UPDATE_MULTILEG_ALL_ORDERS: 'UPDATE_MULTILEG_ALL_ORDERS',
    UPDATE_MULTILEG_OPEN_ORDERS: 'UPDATE_MULTILEG_OPEN_ORDERS',
    GET_ALL_MULTILEG_ORDER_LENGTH: 'GET_ALL_MULTILEG_ORDER_LENGTH',
    GET_OPEN_MULTILEG_ORDER_LENGTH: 'GET_OPEN_MULTILEG_ORDER_LENGTH',
    GET_COMPLETED_MULTILEG_ORDER_LENGTH: 'GET_COMPLETED_MULTILEG_ORDER_LENGTH',
    GET_COMPLETED_MULTILEG_ORDERS_SUCCESS: 'GET_COMPLETED_MULTILEG_ORDERS_SUCCESS',
    GET_COMPLETED_MULTILEG_ORDERS_FAILURE: 'GET_COMPLETED_MULTILEG_ORDERS_FAILURE',
    GET_ALL_MULTILEG_ORDERS_SUCCESS: 'GET_ALL_MULTILEG_ORDERS_SUCCESS',
    GET_ALL_MULTILEG_ORDERS_FAILURE: 'GET_ALL_MULTILEG_ORDERS_FAILURE',
    GET_OPEN_ORDERS_MULTILEG_SUCCESS: 'GET_OPEN_ORDERS_MULTILEG_SUCCESS',
    GET_OPEN_ORDERS_MULTILEG_FAILURE: 'GET_OPEN_ORDERS_MULTILEG_FAILURE',
    MULTILEG_ORDERS_LOADING: 'MULTILEG_ORDERS_LOADING',
    SHOW_SIDETRAY_PLACE_ORDER: 'SHOW_SIDETRAY_PLACE_ORDER',
    SHOW_SIDETRAY_CONIRMATION_ORDER: 'SHOW_SIDETRAY_CONIRMATION_ORDER',
    SHOW_SIDETRAY_ORDER_STATUS: 'SHOW_SIDETRAY_ORDER_STATUS',
    // Ajitesh 12-07-2024 Actions for multileg pagination end
    GET_ALL_EQUITY_SIP_SCRIP_ORDER_LENGTH: 'GET_ALL_EQUITY_SIP_SCRIP_ORDER_LENGTH',
    UPDATE_ORDER_SLICE_REQUEST_DATA: 'UPDATE_ORDER_SLICE_REQUEST_DATA',//BREEZE-16 : Order Slicing Feature : ManasaB : 22-11-2024 : Placing Order for Squareoff issue 
    GET_GTD_META_DATA: 'GET_GTD_META_DATA',
    UPDATE_EXIT_ORDER_DATA: 'EXIT_ORDER_DATA',
    SIDE_TRAY_ORDERS_API_PENDING: 'SIDE_TRAY_ORDERS_API_PENDING'

};

export const HEADERS = {
    GET_USERINFORMATION: 'GET_USERINFORMATION',
    GET_NOTIFICATIONS: 'GET_NOTIFICATIONS',


    UPLOAD_USER_PROFILE_PICTURE_SUCCESS: 'UPLOAD_USER_PROFILE_PICTURE_SUCCESS',
    UPLOAD_USER_PROFILE_PICTURE_FAILURE: 'UPLOAD_USER_PROFILE_PICTURE_FAILURE',

    GET_USER_PREFERENCE_SUCCESS: 'GET_USER_PREFERENCE_SUCCESS',
    GET_USER_PREFERENCE_FAILURE: 'GET_USER_PREFERENCE_FAILURE',
    RESET_USER_PREFERENCE: 'RESET_USER_PREFERENCE',
    GET_USER_PREFERENCE_DATA: 'GET_USER_PREFERENCE_DATA',

    //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
    UPDATE_TENANT_USER_PREFERENCE: 'UPDATE_TENANT_USER_PREFERENCE',
    //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - End

    /* BREEZE-4265 : Ravi R : 05-03-2025: Display segment wise version number -Start */
    SEGMENT_WISE_VERSION_SUCCESS: "SEGMENT_WISE_VERSION_SUCCESS",
    SEGMENT_WISE_VERSION_FAILURE: "SEGMENT_WISE_VERSION_FAILURE"

    /* BREEZE-4265 : Ravi R : 05-03-2025: Display segment wise version number -End */


};

export const FUNDS = {
    GET_BALANCE_SUMMURY: 'GET_BALANCE_SUMMURY',
    GET_MARGIN_DETAILS: 'GET_MARGIN_DETAILS',
    UPI_DETAILS_SUCCESS: 'UPI_DETAILS_SUCCESS',
    UPI_DETAILS_FAILURE: 'UPI_DETAILS_FAILURE',
    PERIODIOCITY_WISE_BALANCE_FAILURE: 'PERIODIOCITY_WISE_BALANCE_FAILURE',
    PERIODIOCITY_WISE_BALANCE_SUCCESS: 'PERIODIOCITY_WISE_BALANCE_SUCCESS',
    SET_PERIODIOCITY_WISE_FUNDS_BREAKUP: 'SET_PERIODIOCITY_WISE_FUNDS_BREAKUP',
    FUNDS_REPORT_SUCCESS: 'FUNDS_REPORT_SUCCESS',
    FUNDS_REPORT_FAILURE: 'FUNDS_REPORT_FAILURE',
    GET_FUNDS_BREAKUPS: 'GET_FUNDS_BREAKUPS',
    GET_TRANSACTIONLIST_GRID: 'GET_TRANSACTIONLIST_GRID',
    GET_FUNDS: 'GET_FUNDS',
    GET_PERIODIOCITIES_SUCCESS: 'GET_PERIODIOCITIES_SUCCESS',
    GET_PERIODIOCITIES_FAILURE: 'GET_PERIODIOCITIES_FAILURE',
    PRODUCT_WISE_BALANCE_SUCCESS: 'PRODUCT_WISE_BALANCE_SUCCESS',
    PRODUCT_WISE_BALANCE_FAILURE: 'PRODUCT_WISE_BALANCE_FAILURE',
    PERIODIOCITY_WISE_BALANCE_TYPE_FAILURE: ' PERIODIOCITY_WISE_BALANCE_TYPE_FAILURE',
    PERIODIOCITY_WISE_BALANCE_TYPE_SUCCESS: ' PERIODIOCITY_WISE_BALANCE_TYPE_SUCCESS',
    // Hari K:08-11-2023 :BT-119138:Funds View - changes are done according to new flow-start
    TRANSFER_MAPPED_PRODUCTS_SUCCESS: 'TRANSFER_MAPPED_PRODUCTS_SUCCESS',
    GET_ALLOWED_MARKETS_SUCCESS: "GET_ALLOWED_MARKETS_SUCCESS",
    GET_ALLOWED_MARKETS_FAILURE: "GET_ALLOWED_MARKETS_FAILURE",
    GET_MANDATE_DETAILS_SUCCESS: 'GET_MANDATE_DETAILS_SUCCESS',
    GET_MANDATE_DETAILS_FAILURE: 'GET_MANDATE_DETAILS_FAILURE',
    GET_BANK_ACCOUNTS_LIST_SUCCESS: "GET_BANK_ACCOUNTS_LIST_SUCCESS",
    GET_BANK_ACCOUNTS_LIST_FAILURE: "GET_BANK_ACCOUNTS_LIST_FAILURE",
    GET_MAPPED_BANK_LIST_SUCCESS: "GET_MAPPED_BANK_LIST_SUCCESS",
    GET_MAPPED_BANK_LIST_FAILURE: "GET_MAPPED_BANK_LIST_FAILURE",
    WITHDRAWAL_SUCCESS: "WITHDRAWAL_SUCCESS",
    WITHDRAWAL_FAILURE: 'WITHDRAWAL_FAILURE',
    TRANSFER_FUNDS_SUCCESS: 'TRANSFER_FUNDS_SUCCESS',
    TRANSFER_FUNDS_FAILURE: 'TRANSFER_FUNDS_FAILURE',
    // Hari K:22-02-2023 :BT-119138:Funds View-start
    GET_NON_BUSINESS_SUCCESS: "GET_NON_BUSINESS_SUCCESS",
    GET_NON_BUSINESS_FAILURE: "GET_NON_BUSINESS_FAILURE",
    GET_AVAILABLE_BANK_LIST_SUCCESS: "GET_AVAILABLE_BANK_LIST_SUCCESS",
    GET_AVAILABLE_BANK_LIST_FAILURE: 'GET_AVAILABLE_BANK_LIST_FAILURE',
    GET_TRANSACTION_PENDING_STATE: 'GET_TRANSACTION_PENDING_STATE',
    GET_PERIODICITY_WISE_BALACE_PENDING_STATE: "GET_PERIODICITY_WISE_BALACE_PENDING_STATE",
    WITHDRAWAL_FUNDS_CANCEL_SUCCESS: "WITHDRAWAL_FUNDS_CANCEL_SUCCESS",
    WITHDRAWAL_FUNDS_CANCEL_FAILURE: "WITHDRAWAL_FUNDS_CANCEL_FAILURE",
    UPDATE_ACTIVE_MARKET: "UPDATE_ACTIVE_MARKET",
    // Hari K:22-02-2023 :BT-119138:Funds View-end
    // Hari K:08-11-2023 :BT-119138:Funds View - changes are done according to new flow-end


};

export const MUTUAL_FUNDS = {
    GET_MUTUALFUND: 'GET_MUTUALFUND',
    GET_THEMES: 'GET_THEMES',
    GET_WACHLIST: 'GET_WACHLIST',
    GET_TRANSACTION_TYPES: 'GET_TRANSACTION_TYPES',
    GET_ORDER_TYPES: 'GET_ORDER_TYPES',
    UPDATE_ACTIVE_ORDER: 'UPDATE_ACTIVE_ORDER',
    GET_ORDERS: 'GET_ORDERS',
    GET_IPO_DETAILS: 'GET_IPO_DETAILS',
    GET_FILTERS: "GET_FILTERS",
    GET_MUTUALFUND_HOLDINGS: "GET_MUTUALFUND_HOLDINGS",
    GET_MUTUALFUND_TYPES: "GET_MUTUALFUND_TYPES",
    GET_FUND_OVERVIEW: "GET_FUND_OVERVIEW",
    GET_SUMMARY: "GET_SUMMARY",

    CREATE_MUTUALFUND_PROFILE: "CREATE_MUTUALFUND_PROFILE",
    CREATE_MUTUALFUND_PROFILE_SUCCESS: "CREATE_MUTUALFUND_PROFILE_SUCCESS",
    CREATE_MUTUALFUND_PROFILE_FAILURE: "CREATE_MUTUALFUND_PROFILE_FAILURE",


    GET_MUTUALFUND_PROFILE_LIST: "GET_MUTUALFUND_PROFILE_LIST",
    GET_MUTUALFUND_PROFILE_LIST_SUCCESS: "GET_MUTUALFUND_PROFILE_LIST_SUCCESS",
    GET_MUTUALFUND_PROFILE_LIST_FAILURE: "GET_MUTUALFUND_PROFILE_LIST_FAILURE",

    DELETE_MUTUALFUND_PROFILE: "DELETE_MUTUALFUND_PROFILE",
    DELETE_MUTUALFUND_PROFILE_SUCCESS: "DELETE_MUTUALFUND_PROFILE_SUCCESS",
    DELETE_MUTUALFUND_PROFILE_FAILURE: "DELETE_MUTUALFUND_PROFILE_FAILURE",

    GET_MUTUALFUND_SEARCH: "GET_MUTUALFUND_SEARCH",
    GET_MUTUALFUND_SEARCH_SUCCESS: "GET_MUTUALFUND_SEARCH_SUCCESS",
    GET_MUTUALFUND_SEARCH_FAILURE: "GET_MUTUALFUND_SEARCH_FAILURE",

    GET_MUTUALFUND_PROFILE_DETAILS: "GET_MUTUALFUND_PROFILE_DETAILS",
    GET_MUTUALFUND_PROFILE_DETAILS_SUCCESS: "GET_MUTUALFUND_PROFILE_DETAILS_SUCCESS",
    GET_MUTUALFUND_PROFILE_DETAILS_FAILURE: "GET_MUTUALFUND_PROFILE_DETAILS_FAILURE",

    // Vinit R : 26-09-2023 :  Breeze - Mutual Funds - End
    GET_MUTUALFUND_HOLDINGS_SUCCESS: "GET_MUTUALFUND_HOLDINGS_SUCCESS",
    GET_MUTUALFUND_HOLDINGS_FAILURE: "GET_MUTUALFUND_HOLDINGS_FAILURE",

    GET_NFO_SUCCESS: 'GET_NFO_SUCCESS',
    GET_NFO_FAILURE: 'GET_NFO_FAILURE',

    GET_MUTUALFUND_SUMMARY_SUCCESS: "GET_MUTUALFUND_SUMMARY_SUCCESS",
    GET_MUTUALFUND_SUMMARY_FAILURE: "GET_MUTUALFUND_SUMMARY_FAILURE",

    GET_MUTUALFUND_ALL_ORDERS_SUCCESS: "GET_MUTUALFUND_ALL_ORDERS_SUCCESS",
    GET_MUTUALFUND_ALL_ORDERS_FAILURE: "GET_MUTUALFUND_ALL_ORDERS_FAILURE",

    GET_SYSTEMATIC_ORDERS_SUCCESS: "GET_SYSTEMATIC_ORDERS_SUCCESS",
    GET_SYSTEMATIC_ORDERS_FAILURE: "GET_SYSTEMATIC_ORDERS_FAILURE",

    PLACE_MUTUALFUND_ORDER_SUCCESS: "PLACE_MUTUALFUND_ORDER_SUCCESS",
    PLACE_MUTUALFUND_ORDER_FAILURE: "PLACE_MUTUALFUND_ORDER_FAILURE",

    PLACE_MUTUALFUND_SIP_ORDER_SUCCESS: "PLACE_MUTUALFUND_SIP_ORDER_SUCCESS",
    PLACE_MUTUALFUND_SIP_ORDER_FAILURE: "PLACE_MUTUALFUND_SIP_ORDER_FAILURE",

    PLACE_MUTUALFUND_STP_ORDER_SUCCESS: "PLACE_MUTUALFUND_STP_ORDER_SUCCESS",
    PLACE_MUTUALFUND_STP_ORDER_FAILURE: "PLACE_MUTUALFUND_STP_ORDER_FAILURE",

    PLACE_MUTUALFUND_SWP_ORDER_SUCCESS: "PLACE_MUTUALFUND_SWP_ORDER_SUCCESS",
    PLACE_MUTUALFUND_SWP_ORDER_FAILURE: "PLACE_MUTUALFUND_SWP_ORDER_FAILURE",

    PLACE_MUTUALFUND_SWITCH_ORDER_SUCCESS: "PLACE_MUTUALFUND_SWITCH_ORDER_SUCCESS",
    PLACE_MUTUALFUND_SWITCH_ORDER_FAILURE: "PLACE_MUTUALFUND_SWITCH_ORDER_FAILURE",

    CANCEL_MUTUALFUND_ORDER_SUCCESS: "CANCEL_MUTUALFUND_ORDER_SUCCESS",
    CANCEL_MUTUALFUND_ORDER_FAILURE: "CANCEL_MUTUALFUND_ORDER_FAILURE",

    GET_MANDATE_SUCCESS: "GET_MANDATE_SUCCESS",
    GET_MANDATE_FAILURE: "GET_MANDATE_FAILURE",

    REGISTER_MANDATE_SUCCESS: "REGISTER_MANDATE_SUCCESS",
    REGISTER_MANDATE_FAILURE: "REGISTER_MANDATE_FAILURE",
    // Vinit R : 26-09-2023 :  Breeze - Mutual Funds - End

    GET_MUTUAL_FUND_WATCHLIST: 'GET_MUTUAL_FUND_WATCHLIST',
    UPDATE_MUTUAL_FUND_WATCHLIST: 'UPDATE_MUTUAL_FUND_WATCHLIST',
    // for mutual fund column definition
    GET_MF_COLUMNDEF_SUCCESS: 'GET_MF_COLUMNDEF_SUCCESS',
    GET_MF_COLUMNDEF_FAILURE: 'GET_MF_COLUMNDEF_FAILURE',
    GET_SCREENERS_GRID_DATA_SUCCESS: 'GET_SCREENERS_GRID_DATA_SUCCESS',
    GET_SCREENERS_GRID_DATA_FAILURE: 'GET_SCREENERS_GRID_DATA_FAILURE',
};

export const SCREENERS = {
    GET_APP_WAVE_SCREENERS_DETAILS_FAILURE: 'GET_APP_WAVE_SCREENERS_DETAILS_FAILURE',
    GET_APP_WAVE_SCREENERS_DETAILS_SUCCESS: 'GET_APP_WAVE_SCREENERS_DETAILS_SUCCESS',
    GET_SCREENERS_GRID_DATA_SUCCESS: 'GET_SCREENERS_GRID_DATA_SUCCESS',
    GET_SCREENERS_GRID_DATA_FAILURE: 'GET_SCREENERS_GRID_DATA_FAILURE',
    SET_IS_GRID_DATA_SHOW: 'SET_IS_GRID_DATA_SHOW',
    SET_CATEGORY_OPTIONS: 'SET_CATEGORY_OPTIONS',
    SET_ACTIVE_SCANNERS_DATA: 'ACTIVE_SCANNERS_DATA',
    SET_FAVOURITE_SCREENERS: 'SET_FAVOURITE_SCREENERS',
    SET_SELECTED_SCREENER: 'SET_SELECTED_SCREENER',
    SET_SELECTED_TAB: 'SET_SELECTED_TAB',
    SET_SELECTED_CATEGORY: 'SET_SELECTED_CATEGORY',
    GET_INDEX_SECTOR_LIST_SUCCESS: 'GET_INDEX_SECTOR_LIST_SUCCESS',
    GET_INDEX_SECTOR_LIST_FAILURE: 'GET_INDEX_SECTOR_LIST_FAILURE',
    GET_PREV_SCANNER: 'GET_PREV_SCANNER',
    GET_NEAR_BOOK_VALUE_DETAILS_SUCCESS: "GET_NEAR_BOOK_VALUE_DETAILS_SUCCESS",
    GET_PREMIUM_DISCOUNT_DETAILS_SUCCESS: "GET_PREMIUM_DISCOUNT_DETAILS_SUCCESS",
    GET_PREMIUM_DISCOUNT_DETAILS_FAILURE: 'GET_PREMIUM_DISCOUNT_DETAILS_FAILURE',
    GET_FII_SUCCESS: 'GET_FII_SUCCESS',
    GET_DII_SUCCESS: 'GET_DII_SUCCESS',
    GET_MF_SUCCESS: 'GET_MF_SUCCESS',
    GET_BULK_SUCCESS: 'GET_BULK_SUCCESS',
    GET_BLOCK_SUCCESS: 'GET_BLOCK_SUCCESS',
    GET_MERGER_ACQ_SUCCESS: 'GET_MERGER_ACQ_SUCCESS'
};
export const RECOMMENDATION = {
    GET_RECOMMENDATIONS: 'GET_RECOMMENDATIONS',
    GET_RECOMMENDATIONS_SUCCESS: 'GET_RECOMMENDATIONS_SUCCESS',
    GET_RECOMMENDATIONS_FAILURE: 'GET_RECOMMENDATIONS_FAILURE',
    GET_RECOMMENDATIONS_ERROR: 'GET_RECOMMENDATION_ERROR',
    TOP_TEN_RECOMMENDATIONS: 'TOP_TEN_RECOMMENDATIONS',
    GET_RECOMMENDATIONS_TAGS: 'GET_RECOMMENDATIONS_TAGS',
    GET_RECOMMENDATIONS_BROKER_TAGS: 'GET_RECOMMENDATIONS_BROKER_TAGS',
    GET_RECOMMENDATIONS_BASKET: 'GET_RECOMMENDATIONS_BASKET',
    UPDATE_ARR_BASKET_RECO: 'UPDATE_ARR_BASKET_RECO',
    UPDATE_CART_COUNT: 'UPDATE_CART_COUNT',
    UPDATE_FORWARD_ICON_STATUS: 'UPDATE_FORWARD_ICON_STATUS'
};

export const NEWS = {
    GET_NEWS: 'GET_NEWS',
    GET_EXCHANGE_ANNOUNCEMENTS_SUCCESS: 'GET_EXCHANGE_ANNOUNCEMENTS_SUCCESS',
    GET_EXCHANGE_ANNOUNCEMENTS_FAILURE: 'GET_EXCHANGE_ANNOUNCEMENTS_FAILURE',
    GET_ANNOUNCEMENTS: 'GET_ANNOUNCEMENTS',
    UPDATE_ACTIVE_NEWS: 'UPDATE_ACTIVE_NEWS',
    GET_NEWS_SECTORS: "GET_NEWS_SECTORS",
    GET_NEWS_SECTORS_SUCCESS: "GET_NEWS_SECTORS_SUCCESS",
    GET_NEWS_SECTORS_FAILURE: "GET_NEWS_SECTORS_FAILURE",
    GET_SECTOR_WISE_NEWS: "GET_SECTOR_WISE_NEWS",
    GET_SECTOR_WISE_NEWS_SUCCESS: "GET_SECTOR_WISE_NEWS_SUCCESS",
    GET_SECTOR_WISE_NEWS_FAILURE: "GET_SECTOR_WISE_NEWS_FAILURE",
    GET_HOT_PURSUIT_NEWS: "GET_HOT_PURSUIT_NEWS",
    GET_HOT_PURSUIT_NEWS_SUCCESS: "GET_HOT_PURSUIT_NEWS_SUCCESS",
    GET_HOT_PURSUIT_NEWS_FAILURE: "GET_HOT_PURSUIT_NEWS_FAILURE",
    GET_SECTOR_WISE_NEWS_DETAILS_SUCCESS: 'GET_SECTOR_WISE_NEWS_DETAILS_SUCCESS',
    GET_SECTOR_WISE_NEWS_DETAILS_FAILURE: 'GET_SECTOR_WISE_NEWS_DETAILS_FAILURE',
    GET_HOT_PURSUIT_DETAILS_SUCCESS: 'GET_HOT_PURSUIT_DETAILS_SUCCESS',
    GET_HOT_PURSUIT_DETAILS_FAILURE: 'GET_HOT_PURSUIT_DETAILS_FAILURE',
    GET_OTHER_NEWS_DATA: 'GET_OTHER_NEWS_DATA',
    GET_FII_SUCCESS: 'GET_FII_SUCCESS',
    GET_DII_SUCCESS: 'GET_DII_SUCCESS',
    GET_MF_SUCCESS: 'GET_MF_SUCCESS',
    GET_FII_FAILURE: 'GET_FII_FAILURE',
    GET_DII_FAILURE: 'GET_DII_FAILURE',
    GET_MF_FAILURE: 'GET_MF_FAILURE',
    GET_BULK_BLOCK_DEAL_SUCCESS: "GET_BULK_BLOCK_DEAL_SUCCESS",
    GET_BULK_BLOCK_DEAL_FAILURE: 'GET_BULK_BLOCK_DEAL_FAILURE',
    GET_MERGER_DEMERGER_SUCCESS: 'GET_MERGER_DEMERGER_SUCCESS',
    GET_MERGER_DEMERGER_FAILURE: 'GET_MERGER_DEMERGER_FAILURE',
    CLEAR_NEWS_STATE: 'CLEAR_NEWS_STATE',
    CLEAR_ANNOUNCEMENT_STATE: 'CLEAR_ANNOUNCEMENT_STATE',
    IS_REACHED_LIMIT: "IS_REACHED_LIMIT",
    GET_HOLDINGS_NES_SUCCESS: "GET_HOLDINGS_NES_SUCCESS",
    GET_HOLDINGS_NES_FAILURE: "GET_HOLDINGS_NES_FAILURE",
    UPDATE_ACTIVE_TAB: "UPDATE_ACTIVE_TAB",
    UPDATE_ANNOUNCEMENT_TYPE: "UPDATE_ANNOUNCEMENT_TYPE",
    UPDATE_NEWS_SECTOR: " UPDATE_NEWS_SECTOR",
    UPDATE_NEWS_SEARCH_TEXT: 'UPDATE_NEWS_SEARCH_TEXT',
    CLEAR_NEWS_DETAIL_STATES: 'CLEAR_NEWS_DETAIL_STATES',
    UPDATE_ANNOUNCEMENT_STATUS: 'UPDATE_ANNOUNCEMENT_STATUS',
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start 
    IS_NEWS_API_PENDING: 'IS_NEWS_API_PENDING',
    IS_HOTPURSSUIT_API_PENDING: 'IS_HOTPURSSUIT_API_PENDING',
    IS_ANNOUNCEMENT_API_PENDING: 'IS_ANNOUNCEMENT_API_PENDING',
    IS_SECTORWISE_NEWS_DETAILS_API_PENDING: 'IS_SECTORWISE_NEWS_DETAILS_API_PENDING',
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End ,
    UPDATE_VISBLE_SCRIP_FOR_SUB_AND_UNSUB: 'UPDATE_VISBLE_SCRIP_FOR_SUB_AND_UNSUB'
};
export const IPO = {
    GET_IPO: 'GET_IPO',
    GET_IPO_DETAILS: 'GET_IPO_DETAILS',

    GET_ONGOING_IPO_SUCCESS: "GET_ONGOING_IPO_SUCCESS",
    GET_ONGOING_IPO_FAILURE: "GET_ONGOING_IPO_FAILURE",

    GET_FUTURE_IPO_SUCCESS: "GET_FUTURE_IPO_SUCCESS",
    GET_FUTURE_IPO_FAILURE: "GET_FUTURE_IPO_FAILURE",

    GET_PAST_IPO_SUCCESS: "GET_PAST_IPO_SUCCESS",
    GET_PAST_IPO_FAILURE: "GET_PAST_IPO_FAILURE",

    GET_IPO_DETAILS_SUCCESS: "GET_IPO_DETAILS_SUCCESS",
    GET_IPO_DETAILS_FAILURE: "GET_IPO_DETAILS_FAILURE",

    GET_PLACEMODIFY_BID_SUCCESS: "GET_PLACEMODIFY_BID_SUCCESS",
    GET_PLACEMODIFY_BID_FAILURE: "GET_PLACEMODIFY_BID_FAILURE",

    GET_ORDERBOOK_SUCCESS: "GET_ORDERBOOK_SUCCESS",
    GET_ORDERBOOK_FAILURE: "GET_ORDERBOOK_FAILURE",

    GET_CANCELBID_SUCCESS: "GET_CANCELBID_SUCCESS",
    GET_CANCELBID_FAILURE: "GET_CANCELBID_FAILURE",

    GET_TERMS_AND_CONDITION_FAILURE_IPO: "GET_TERMS_AND_CONDITION_FAILURE_IPO",
    GET_TERMS_AND_CONDITION_SUCCESS_IPO: "GET_TERMS_AND_CONDITION_SUCCESS_IPO",
    UPDATE_IS_CMOT: "UPDATE_IS_CMOT",
    UPDATE_ANNOUNCEMENT_STATUS: 'UPDATE_ANNOUNCEMENT_STATUS',
    GET_IPO_QUICK_BID: 'GET_IPO_QUICK_BID'
};

export const SCRIP_SEARCH = {

    IS_LOADING: 'IS_LOADING',

    GET_SEARCH_ALL_SCRIPS_SUCCESS: 'GET_SEARCH_ALL_SCRIPS_SUCCESS',
    GET_SEARCH_ALL_SCRIPS_FAILURE: 'GET_SEARCH_ALL_SCRIPS_FAILURE',

    GET_SEARCH_EQ_SCRIPS_SUCCESS: 'GET_SEARCH_EQ_SCRIPS_SUCCESS',
    GET_SEARCH_EQ_SCRIPS_FAILURE: 'GET_SEARCH_EQ_SCRIPS_FAILURE',

    GET_SEARCH_FUT_SCRIPS_SUCCESS: 'GET_SEARCH_FUT_SCRIPS_SUCCESS',
    GET_SEARCH_FUT_SCRIPS_FAILURE: 'GET_SEARCH_FUT_SCRIPS_FAILURE',

    GET_SEARCH_OPT_SCRIPS_SUCCESS: 'GET_SEARCH_OPT_SCRIPS_SUCCESS',
    GET_SEARCH_OPT_SCRIPS_FAILURE: 'GET_SEARCH_OPT_SCRIPS_FAILURE',

    GET_SEARCH_MF_SCRIPS_SUCCESS: 'GET_SEARCH_MF_SCRIPS_SUCCESS',
    GET_SEARCH_MF_SCRIPS_FAILURE: 'GET_SEARCH_MF_SCRIPS_FAILURE',

    UPDATE_SEARCH_PAGES: 'UPDATE_SEARCH_PAGES',
    //As per PR comments added to redux state : Manasa B : 28/08/2023 - Start
    GET_SEARCH_RECOMMENDATION_SCRIPS_SUCCESS: 'GET_SEARCH_RECOMMENDATION_SCRIPS_SUCCESS',
    GET_SEARCH_RECOMMENDATION_SCRIPS_FAILURE: 'GET_SEARCH_RECOMMENDATION_SCRIPS_FAILURE',

    GET_SEARCH_ALERT_SCRIPS_SUCCESS: 'GET_SEARCH_ALERT_SCRIPS_SUCCESS',
    GET_SEARCH_ALERT_SCRIPS_FAILURE: 'GET_SEARCH_ALERT_SCRIPS_FAILURE',

    GET_SEARCH_EVENT_SCRIPS_SUCCESS: 'GET_SEARCH_EVENT_SCRIPS_SUCCESS',
    GET_SEARCH_EVENT_SCRIPS_FAILURE: 'GET_SEARCH_EVENT_SCRIPS_FAILURE',

    GET_SEARCH_IPO_SCRIPS_SUCCESS: 'GET_SEARCH_IPO_SCRIPS_SUCCESS',
    GET_SEARCH_IPO_SCRIPS_FAILURE: 'GET_SEARCH_IPO_SCRIPS_FAILURE',

    GET_SEARCH_NEWS_SCRIPS_SUCCESS: 'GET_SEARCH_NEWS_SCRIPS_SUCCESS',
    GET_SEARCH_NEWS_SCRIPS_FAILURE: 'GET_SEARCH_NEWS_SCRIPS_FAILURE',

    UPDATE_SEARCH_SCRIP_DATA_STATUS_SUCCESS: 'UPDATE_SEARCH_SCRIP_DATA_STATUS_SUCCESS',
    UPDATE_SEARCH_SCRIP_DATA_STATUS_FAILURE: ' UPDATE_SEARCH_SCRIP_DATA_STATUS_FAILURE',

    // BT-118877 : Functional Implementation - Global Search : Vinit R : 09/10/2023 - Start 
    UPDATE_SEARCH_MF_SCRIP_DATA_STATUS_SUCCESS: 'UPDATE_SEARCH_MF_SCRIP_DATA_STATUS_SUCCESS',
    UPDATE_SEARCH_MF_SCRIP_DATA_STATUS_FAILURE: 'UPDATE_SEARCH_MF_SCRIP_DATA_STATUS_FAILURE',
    // BT-118877 : Functional Implementation - Global Search : Vinit R : 09/10/2023 - End 

    //As per PR comments added to redux state : Manasa B : 28/08/2023 - End
    RECENT_SEARCH_SCRIPS: 'RECENT_SEARCH_SCRIPS',
    TRENDING_SEARCH_SCRIPS: 'TRENDING_SEARCH_SCRIPS',
    // BT-118877 : Functional Implementation - Global Search : Vinit R : 09/10/2023 - Start 
    RECENT_SEARCH_MF_SCRIPS: 'RECENT_SEARCH_MF_SCRIPS',
    // BT-118877 : Functional Implementation - Global Search : Vinit R : 09/10/2023 - End 
    UPDATE_TOTAL_PAGES: 'UPDATE_TOTAL_PAGES',
    UPDATE_GLOBAL_ADDSCRIP_WATCHLIST: 'UPDATE_GLOBAL_ADDSCRIP_WATCHLIST'
};
export const SET_ARR_SCRIPS_TO_BE_ADDED = 'SET_ARR_SCRIPS_TO_BE_ADDED';
export const WFH = {
    UPDATE_TOUCHLINE_LAST_TICK: 'UPDATE_TOUCHLINE_LAST_TICK',
    UPDATE_BESTFIVE_LAST_TICK: 'UPDATE_BESTFIVE_LAST_TICK',
    UPDATE_TOUCHLINE_OBJ: 'UPDATE_TOUCHLINE_OBJ',
    UPDATE_BEST_FIVE_OBJ: 'UPDATE_BEST_FIVE_OBJ',
    UPDATE_RECONNECTION_COUNT: 'UPDATE_RECONNECTION_COUNT'
};

export const GET_SIMPLE_MOVING_AVERAGES = "GET_SIMPLE_MOVING_AVERAGES";
export const GET_SIMPLE_MOVING_AVERAGES_FAILURE = "GET_SIMPLE_MOVING_AVERAGES_FAILURE";
export const GET_MARKET_MOVEMENT_FAILURE = "GET_MARKET_MOVEMENT_FAILURE";

export const GET_KEYSTATS = "GET_KEYSTATS";
export const GET_FUTURE_DATA = "GET_FUTURE_DATA";
export const GET_KEYSTATS_FAILURE = "GET_KEYSTATS_FAILURE";
//export const GET_FUTURE_DATA: "GET_FUTURE_DATA";
export const GET_MARKET_PULSE = 'GET_MARKET_PULSE';
export const UPDATE_MARKET_DEPTH = 'UPDATE_MARKET_DEPTH';

//scrip overview - company info
export const GET_MANAGEMENT_DETAILS = 'GET_MANAGEMENT_DETAILS';
export const GET_COMPANY_HISTORY = "GET_COMPANY_HISTORY";
export const GET_CODE_INFO = "GET_CODE_INFO";
export const GET_CONTRACT_CODE_INFO = "GET_CONTRACT_CODE_INFO";
export const GET_SECURITY_DETAILS = 'GET_SECURITY_DETAILS';
export const GET_CONTRACT_DETAILS = 'GET_CONTRACT_DETAILS';
export const GET_CONTRACT_MARGIN_DETAILS = 'GET_CONTRACT_MARGIN_DETAILS';
export const GET_LISTING_INFO = "GET_LISTING_INFO";
export const GET_PARTS_OF_INDICES = "GET_PARTS_OF_INDICES";
export const GET_RECORD_DATA = "GET_RECORD_DATA";
export const GET_GSM_CATEGORY = 'GET_GSM_CATEGORY';
export const GET_COMPANY_EXCHANGE_DATA = "GET_COMPANY_EXCHANGE_DATA";
export const GET_COMPANY_BACKGROUND_DATA = 'GET_COMPANY_BACKGROUND_DATA';
export const GET_COMPANY_INFO_FAILURE = 'GET_COMPANY_INFO_FAILURE';
export const GET_BOARD_OF_DIRECTOR_FAILURE = 'GET_BOARD_OF_DIRECTOR_FAILURE';
export const GET_FUTURE_TAB_DATA_SUCCESS = "GET_FUTURE_TAB_DATA_SUCCESS";
export const GET_FUTURE_TAB_DATA_FAILURE = "GET_FUTURE_TAB_DATA_FAILURE";
export const GET_SECURITY_INFO_FAILURE = "GET_SECURITY_INFO_FAILURE";
export const GET_CONTARCT_FAILURE = "GET_CONTARCT_FAILURE";
export const GET_COMPANY_LISTING_INFO_FAILURE = "GET_COMPANY_LISTING_INFO_FAILURE";
export const GET_COMPANY_EXCHANGE_DATA_FAILURE = "GET_COMPANY_EXCHANGE_DATA_FAILURE";
export const GET_CODE_FAILURE = "GET_CODE_FAILURE";
export const GET_RECORDDATA_FAILURE = "GET_RECORDDATA_FAILURE";
export const GET_COMPANY_BACKGROUND_FAILURE = "GET_COMPANY_BACKGROUND_FAILURE";
export const GET_GSM_CATEGORY_FAILURE = 'GET_GSM_CATEGORY_FAILURE';
export const SEARCH_DONTMISS_BY_SYMBOL = 'SEARCH_DONTMISS_BY_SYMBOL';
export const SEARCH_DONTMISS_BY_DROPDOWN = 'SEARCH_DONTMISS_BY_DROPDOWN';
export const GET_QUARTERLY_TREND_SUCCESS = 'GET_QUARTERLY_TREND_SUCCESS';
export const GET_QUARTERLY_TREND_FAILURE = 'GET_QUARTERLY_TREND_FAILURE';
export const GET_SHARE_HOLDING_PATTERN_DATA_SUCCESS = 'GET_SHARE_HOLDING_PATTERN_DATA_SUCCESS';
export const GET_SHARE_HOLDING_PATTERN_DATA_FAILURE = 'GET_SHARE_HOLDING_PATTERN_DATA_FAILURE';
export const GET_COMPANY_RESULT_DATA_SUCCESS = 'GET_COMPANY_RESULT_DATA_SUCCESS';
export const GET_COMPANY_RESULT_DATA_FAILURE = 'GET_COMPANY_RESULT_DATA_FAILURE';
export const GET_PROFIT_LOSS_DATA_SUCCESS = 'GET_PROFIT_LOSS_DATA_SUCCESS';
export const GET_PROFIT_LOSS_DATA_FAILURE = 'GET_PROFIT_LOSS_DATA_FAILURE';
export const GET_COMPANY_BALANCE_SHEET_DATA_SUCCESS = 'GET_COMPANY_BALANCE_SHEET_DATA_SUCCESS';
export const GET_COMPANY_BALANCE_SHEET_DATA_FAILURE = 'GET_COMPANY_BALANCE_SHEET_DATA_FAILURE';
export const GET_OI_DATA_FOR_SCRIP_SUCCESS_1 = 'GET_OI_DATA_FOR_SCRIP_SUCCESS_1';
export const GET_OI_DATA_FOR_SCRIP_FAILURE_1 = 'GET_OI_DATA_FOR_SCRIP_FAILURE_1';
export const GET_OI_DATA_FOR_SCRIP_SUCCESS_2 = 'GET_OI_DATA_FOR_SCRIP_SUCCESS_2';
export const GET_OI_DATA_FOR_SCRIP_FAILURE_2 = 'GET_OI_DATA_FOR_SCRIP_FAILURE_2';
export const GET_OI_DATA_FOR_SCRIP_SUCCESS_3 = 'GET_OI_DATA_FOR_SCRIP_SUCCESS_3';
export const GET_OI_DATA_FOR_SCRIP_FAILURE_3 = 'GET_OI_DATA_FOR_SCRIP_FAILURE_3';
export const GET_PUT_CALL_MASTER_DATA_SUCCESS = 'GET_PUT_CALL_MASTER_DATA_SUCCESS';
export const GET_PUT_CALL_MASTER_DATA_FAILURE = 'GET_PUT_CALL_MASTER_DATA_FAILURE';
export const GET_HEALTH_SCORE_FAILURE = 'GET_HEALTH_SCORE_FAILURE';
export const GET_HEALTH_SCORE_SUCCESS = 'GET_HEALTH_SCORE_SUCCESS';
export const GET_PEER_COMPARISON_FAILURE = 'GET_PEER_COMPARISON_FAILURE';
export const GET_PEER_COMPARISON_SUCCESS = 'GET_PEER_COMPARISON_SUCCESS';
export const SET_SCRIP_OVERVIEW_DATA = "SET_SCRIP_OVERVIEW_DATA";
export const SET_ARR_ROW_DATA = "SET_ARR_ROW_DATA";
export const RESET_MARKET_OVERVIEW = "RESET_MARKET_OVERVIEW";
export const GET_HEALTH_PARAM_SCORE_SUCCESS = 'GET_HEALTH_PARAM_SCORE_SUCCESS';
export const GET_HEALTH_PARAM_SCORE_FAILURE = 'GET_HEALTH_PARAM_SCORE_FAILURE';
export const GET_HEALTH_PARAM_VALUE_SUCCESS = 'GET_HEALTH_PARAM_VALUE_SUCCESS';
export const GET_HEALTH_PARAM_VALUE_FAILURE = 'GET_HEALTH_PARAM_VALUE_FAILURE';

export const GET_MARKET_PULSE_FAILURE = 'GET_MARKET_PULSE_FAILURE';
export const GET_SCRIPOVERVIEW_MARKET_PULSE_SUCCESS = 'GET_MARKET_PULSE_FAILURE';
export const GET_SCRIP_MARKET_PULSE_SUCCESS = 'GET_SCRIP_MARKET_PULSE_SUCCESS';
export const GET_PLACEORDER_MULTILEG = 'GET_PLACEORDER_MULTILEG';
export const GET_DELIVERY_QUANTITY = 'GET_DELIVERY_QUANTITY';
export const GET_DELIVERY_QUANTITY_FAILURE = 'GET_DELIVERY_QUANTITY_FAILURE';

export const HANDLE_MODALS = "HANDLE_MODALS";
export const HANDLE_MODALS_DATA = "HANDLE_MODALS_DATA";

export const GET_MARKET_MOVEMENT_FAILURE_NEW = 'GET_MARKET_MOVEMENT_FAILURE_NEW';
export const GET_MARKET_MOVEMENT_SUCCESS = 'GET_MARKET_MOVEMENT_SUCCESS';

export const SET_AVAILABLE_EXCHANGES = 'SET_AVAILABLE_EXCHANGES';
export const RESET_COMPANY_CONTRACT_INFO = 'RESET_COMPANY_CONTRACT_INFO';
// Vinit R - 05-04-2024 Company Info to be kept common irrespective of exchanges -- Start
export const SET_COMMON_COMPANY_CONTRACT_INFO = 'SET_COMMON_COMPANY_CONTRACT_INFO';
// Vinit R - 05-04-2024 Company Info to be kept common irrespective of exchanges -- End
export const GET_FINANCIAL_RATIO_DATA = 'GET_FINANCIAL_RATIO_DATA';
export const UPDATE_CONSTITUENT_VIEW = 'UPDATE_CONSTITUENT_VIEW';
export const GET_FUTURES_COLUMNS_LIST = 'GET_FUTURES_COLUMNS_LIST';
export const GET_CONSTITUENTS_COLUMNS_LIST = 'GET_CONSTITUENTS_COLUMNS_LIST';
export const EXPAND_SIDE_CHART = 'EXPAND_SIDE_CHART';
export const SIDE_OVERVIEW_WATCHLIST_SYNC = 'SIDE_OVERVIEW_WATCHLIST_SYNC';
export const OVER_VIEW_CARD = {
    UPDATE_OVERVIEW_ACTIVE_TAB: 'UPDATE_OVERVIEW_ACTIVE_TAB'
};

export const TOAST = {
    HANDLE_TOAST: "HANDLE_TOAST",
    HANDLE_CHILDREN_DATA: "HANDLE_CHILDREN_DATA",
    REMOVE_TOAST: "REMOVE_TOAST"
};

export const SETTING = {
    GET_SETTING: 'GET_SETTING',
    GET_SETTING_FAILURE: 'GET_SETTING_FAILURE',
    GET_PUSH_NOTIFICATION_TOPIC_SUCCESS: 'GET_PUSH_NOTIFICATION_TOPIC_SUCCESS',
    GET_PUSH_NOTIFICATION_TOPIC_FAILURE: 'GET_PUSH_NOTIFICATION_TOPIC_FAILURE',
    //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
    PUSH_NOTIFICATION_TOPIC_SUB_UNSUB_SUCCESS: 'PUSH_NOTIFICATION_TOPIC_SUB_UNSUB_SUCCESS',
    PUSH_NOTIFICATION_TOPIC_SUB_UNSUB_FAILURE: 'PUSH_NOTIFICATION_TOPIC_SUB_UNSUB_FAILURE',
    //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - End

};
export const MESSAGES = {
    GET_MESSAGES: 'GET_MESSAGES',
    GET_MESSAGES_BROKER: 'GET_MESSAGES_BROKER',
    GET_MESSAGES_ORDERS: 'GET_MESSAGES_ORDERS',
    GET_MESSAGES_NSE: 'GET_MESSAGES_NSE',
    GET_MESSAGES_SUCCESS: 'GET_MESSAGES_SUCCESS',
    GET_MESSAGES_FAILURE: 'GET_MESSAGES_FAILURE',
    SET_COUNT_EXCHANGE: 'SET_COUNT_EXCHANGE',
    SET_COUNT_BROKER: 'SET_COUNT_BROKER',
    SET_COUNT_ORDER: 'SET_COUNT_ORDER',
    // Hari K : 02-11-2023 : SAT-109371 : Message Hub  – Start/
    UPDATE_NOTIFICATION_COUNT_STATUS: 'UPDATE_NOTIFICATION_COUNT_STATUS',
    GET_MESSAGE_BROKER_FAILURE: 'GET_MESSAGE_BROKER_FAILURE',
    GET_MESSAGE_ORDER_FAILURE: 'GET_MESSAGE_ORDER_FAILURE',
    GET_MESSAGE_NSE_FAILURE: 'GET_MESSAGE_NSE_FAILURE',
    CLEAR_NSE_STATE: 'CLEAR_NSE_STATE',
    // Hari K : 02-11-2023 : SAT-109371 : Message Hub – Start/

    // Ameersha N : 24-11-2023 : SAT-109371 : Message Hub – Start/
    UPDATE_MSG_ACTIVE_CHIP: 'UPDATE_MSG_ACTIVE_CHIP',
    UPDATE_STR_NOTIFCATION_EXCHANGE: 'UPDATE_STR_NOTIFCATION_EXCHANGE',
    GET_NSE_PENDING_STATUS: "GET_NSE_PENDING_STATUS",
    GET_ORDER_MESSAGE_STATUS: 'GET_ORDER_MESSAGE_STATUS',
    GET_BROKER_MESSAGE_STATUS: 'GET_BROKER_MESSAGE_STATUS'
    // Ameersha N : 24-11-2023 : SAT-109371 : Message Hub – End/

};

export const NOTIFICATION = {
    GET_NOTIFICATION: 'GET_NOTIFICATION',
    GET_NOTIFICATION_BROKER: 'GET_NOTIFICATION_BROKER',
    GET_NOTIFICATION_ORDERS: 'GET_NOTIFICATION_ORDERS',
    GET_NOTIFICATION_NSE: 'GET_NOTIFICATION_NSE',
    GET_NOTIFICATION_SUCCESS: 'GET_NOTIFICATION_SUCCESS',
    GET_NOTIFICATION_FAILURE: 'GET_NOTIFICATION_FAILURE'
};

export const ALERTS = {
    GET_ALERTS: 'GET_ALERTS',
    GET_ALERTS_SUCCESS: 'GET_ALERTS_SUCCESS',
    GET_ALERTS_FAILURE: 'GET_ALERTS_FAILURE',
    SET_ALERTS_SUCCESS: 'SET_ALERTS_SUCCESS',
    SET_ALERTS_FAILURE: 'SET_ALERTS_FAILURE',
    GET_ALERT_TRIGGED_SUCCESS: 'GET_ALERT_TRIGGED',
    MODIFY_ALERT_RESPONCE: 'MODIFY_ALERT_RESPONCE',
    DELETE_ALERT_RESPONCE: 'DELETE_ALERT_RESPONCE',
    SEARCH_ALERT_BY_SYMBOL: 'SEARCH_ALERT_BY_SYMBOL',
    SEARCH_ALERT_BY_DROPDOWN: 'SEARCH_ALERT_BY_DROPDOWN',
    SET_ACTIVE_ALERT_TAB_BY_DEFAULT: 'SET_ACTIVE_ALERT_TAB_BY_DEFAULT',
    SET_TRIGGER_ALERT_COUNT: 'SET_TRIGGER_ALERT_COUNT',
    GET_ALERT_TRIGGED_FAILURE: 'GET_ALERT_TRIGGED_FAILURE'
};

// Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
export const ADDENDUMANDNOTICES = {
    GET_ADD_ENDUMAND_NOTICES: 'GET_ADD_ENDUMAND_NOTICES',
    GET_ADD_ENDUMAND_NOTICES_SUCCESS: 'GET_ADD_ENDUMAND_NOTICES_SUCCESS',
    GET_ADD_ENDUMAND_NOTICES_FAILURE: 'GET_ADD_ENDUMAND_NOTICES_SUCCESS',
    UPDATE_IS_ADD_END_DUM_ACCEPTED_OR_REJECTED: 'UPDATE_IS_ADD_END_DUM_ACCEPTED_OR_REJECTED',
    UPDATE_IS_ADD_ENDUM_MODAL_OPEN: 'UPDATE_IS_ADD_ENDUM_MODAL_OPEN',
    UPDATE_ADD_ENDUM_NOTICES_REPORT: 'UPDATE_ADD_ENDUM_NOTICES_REPORT',
    UPDATE_ADD_NOT_LAST_LOCATION: 'UPDATE_ADD_NOT_LAST_LOCATION'
};
// Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --End
export const SCRIPINFO = {
    GET_SCRIP_INFO_SUCCESS: 'GET_SCRIP_INFO_SUCCESS',
    GET_SCRIP_INFO_FAILURE: 'GET_SCRIP_INFO_FAILURE',
    UPDATE_OBJ_VISIBLE_SCRIPS: "UPDATE_OBJ_VISIBLE_SCRIPS"
};


export const OPTION_CHAIN = {
    SAVE_OPTION_DATA: 'SAVE_OPTION_DATA',
    SAVE_DISTINCT_DATES: 'SAVE_DISTINCT_DATES',
    SAVE_DISTINCT_DATES_OPTIONS: 'SAVE_DISTINCT_DATES_OPTIONS',
    SCRIP_DATA: 'SCRIP_DATA',
    SELECTED_TAB: 'SELECTED_TAB',
    CHECKBOXES: 'CHECKBOXES',
    OPTION_DATA_WRT_EXPIRY: 'OPTION_DATA_WRT_EXPIRY',
    SELECTED_ROWS: 'SELECTED_ROWS',
    SELECTED_DATE: 'SELECTED_DATE',
    MULTI_LEG_DATA: 'MULTI_LEG_DATA',
    GLOBAL_SEARCH_ONLY_OPTION_CHAIN_DATA: 'GLOBAL_SEARCH_ONLY_OPTION_CHAIN_DATA',
    GLOBAL_SEARCH_FUT_OPTION_SCRIPS: 'GLOBAL_SEARCH_FUT_OPTION_SCRIPS',
    OPTION_CHAIN_POPOVER_UPDATE: 'OPTION_CHAIN_POPOVER_UPDATE',
    UPDATE_VISIBLESCRIPS_FOR_OPTION_CHAIN: 'UPDATE_VISIBLESCRIPS_FOR_OPTION_CHAIN',
    // After this line everything is new for new option chain
    OPTION_CHAIN_DUMMY_DATA: 'OPTION_CHAIN_DUMMY_DATA',
    OPTION_CHAIN_TOGGLE_CHECKBOX: 'OPTION_CHAIN_TOGGLE_CHECKBOX',
    UPDATE_OPTION_CHAIN_ARR_STRIKE_PRICES: 'UPDATE_OPTION_CHAIN_ARR_STRIKE_PRICES',
    UPDATE_OPTION_CHAIN_PAYLOAD: 'UPDATE_OPTION_CHAIN_PAYLOAD',
    UPDATE_OPTION_CHAIN_LOADING: 'UPDATE_OPTION_CHAIN_LOADING',
    CLEAR_OPTION_CHAIN_DATA: 'CLEAR_OPTION_CHAIN_DATA',
    UPDATE_OBJ_MULTILEG_DATA: 'UPDATE_OBJ_MULTILEG_DATA',
    LEG_DATA_FOR_OPTION_CHAIN: 'LEG_DATA_FOR_OPTION_CHAIN',
    OPTION_CHAIN_LAST_STACK: 'OPTION_CHAIN_LAST_STACK',
    IS_SIDE_OPTION_CHAIN_STICKED: 'IS_SIDE_OPTION_CHAIN_STICKED'

};


//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
export const GUEST_USER_PREVALAGES = {
    UPDATE_GUEST_USER_PREVALAGES_SUCCESS: 'UPDATE_GUEST_USER_PREVALAGES_SUCCESS',
    UPDATE_GUEST_USER_PREVALAGES_FAILURE: 'UPDATE_GUEST_USER_PREVALAGES_FAILURE'
};
//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End
export const ORDER_CART = {
    GET_ORDER_CART_SUCCES: 'GET_ORDER_CART_SUCCES',
    GET_ORDER_CART_FAIL: 'GET_ORDER_CART_FAIL',
    UPDATE_ORDER_CART_SELECTED_ROW: 'UPDATE_ORDER_CART_SELECTED_ROW',
    CART_SAVED_SUCCESS: 'CART_SAVED_SUCCESS',
    ORDERENTRY_GRID_DATA: 'ORDERENTRY_GRID_DATA',
    ORDERENTRY_CART_API_PENDING: 'ORDERENTRY_CART_API_PENDING',
    CART_SAVED_GOBACK: 'CART_SAVED_GOBACK',//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 08-04-2024
    UPDATE_ORDER_CART_MARGIN: 'UPDATE_ORDER_CART_MARGIN',
    GET_ORDER_CART_SCRIPS: 'GET_ORDER_CART_SCRIPS',//BT-106965 : Order Cart : ManasaB : 23-07-2024 : Side tray code changes 
    PLACE_ORDERCART_ORDER_SUCCESS: 'PLACE_ORDERCART_ORDER_SUCCESS',//BT-106965 : Order Cart : ManasaB : 23-07-2024 : Side tray code changes  
    GET_ORDER_CART_BACKUP_VERTICAL: 'GET_ORDER_CART_BACKUP_VERTICAL',//BT-106965 : Order Cart : ManasaB : 25-07-2024 : Side tray code changes 
    GET_ORDER_MARKET_PRICE: 'GET_ORDER_MARKET_PRICE',
    GET_ORDERCART_OPTIONCHAIN: 'GET_ORDERCART_OPTIONCHAIN',
    CONVERT_TO_ORDERCART: 'CONVERT_TO_ORDERCART',
    UPDATE_PREV_ORDERINFO: ' UPDATE_PREV_ORDERINFO',
    UPDATE_ISBASKET_CLICKED: 'UPDATE_ISBASKET_CLICKED'

};
//BT-107433 : Calculator : SAT Issues : ManasaB : 07-03-2024 - Start
export const CALCULATOR = {
    GET_EXPIRY_DATES: 'GET_EXPIRY_DATES',
    GET_STRIKE_PRICE: 'GET_STRIKE_PRICE'
};
//BT-107433 : Calculator : SAT Issues : ManasaB : 07-03-2024 - End

// Ajitesh : 16/11/2023: BT-109135: Breeze eDIS implementation - Start
export const GET_DP_DETAILS_SUCCESS = "GET_DP_DETAILS_SUCCESS";
export const GET_DP_DETAILS_FAILURE = "GET_DP_DETAILS_FAILURE";
export const GET_INTEROP_CONFIG_DETAILS_SUCCESS = "GET_INTEROP_CONFIG_DETAILS_SUCCESS";
export const GET_INTEROP_CONFIG_DETAILS_FAILURE = "GET_INTEROP_CONFIG_DETAILS_FAILURE";
// Ajitesh : 16/11/2023: BT-109135: Breeze eDIS implementation - End
export const GET_DEVICE_INFO = "GET_DEVICE_INFO";
// Ajitesh : 21/11/2023: BT-109135: Breeze eDIS implementation - Start
// K Hari :13-03-2023: Manage columns-start
export const UPDATE_DEFAULT_MANAGE_COLUMN_NAME = "UPDATE_DEFAULT_MANAGE_COLUMN_NAME";
// K Hari :13-03-2023: Manage columns-end
export const EDIS = {
    EDIS_SUMMARY_DETAILS_SUCCESS: "EDIS_SUMMARY_DETAILS_SUCCESS",
    EDIS_SUMMARY_DETAILS_FAILURE: "EDIS_SUMMARY_DETAILS_FAILURE",
    GENERATE_TPIN_SUCCESS: "GENERATE_TPIN_SUCCESS",
    GENERATE_TPIN_FAILURE: "GENERATE_TPIN_FAILURE",
    UPDATE_EDIS_IS_LOADING: "UPDATE_EDIS_IS_LOADING",
};
// Ajitesh : 21/11/2023: BT-109135: Breeze eDIS implementation - End

// Ajitesh : 16/02/2024: BT-109380 Contact Us - Start
export const HELP = {
    UPDATE_IS_LOADING_BRANCHES_INFO: "UPDATE_IS_LOADING_BRANCHES_INFO",
    GET_BRANCH_DETAILS_SUCCESS: "GET_BRANCH_DETAILS_SUCCESS",
    GET_BRANCH_DETAILS_FAILURE: "GET_BRANCH_DETAILS_FAILURE"
};
// Ajitesh : 16/02/2024: BT-109380 Contact Us - End


export const COLUMNS_UNMOUNT_GRID = {
    UPDATE_ARR_COLUMNS_UNMOUNT: 'UPDATE_ARR_COLUMNS_UNMOUNT'
};